<template>
    <b-navbar-brand
        class="text-light"
    >
        <img v-if="group.logo_url" height="32" :src="group.logo_url" style="filter: brightness(0) invert(1);" />
        <LogoPlaceholder v-else />
    </b-navbar-brand>
</template>
<script>
import { mapState } from 'vuex';
import LogoPlaceholder from './LogoPlaceholder.vue';
export default {
    components: { LogoPlaceholder, LogoPlaceholder },
    computed: mapState(["group"])
}
</script>